export enum LocalStorageKey {
  key = 'admin-lk-token',
}
